import { useT } from '@/lib/useLang';

export function Trust() {
  const t = useT();

  return (
    <section id="trust" className="nz-trust">
      <div className="nz-split nz-split--center">
        <div>
          <div className="nz-eyebrow">{t.trustEyebrow}</div>
          <h2 className="nz-h2">{t.trustH2}</h2>
          <p className="nz-lead">{t.trustP}</p>
        </div>

        <div className="nz-trust__list">
          <div className="nz-in" aria-hidden="true">
            in
          </div>
          <ul>
            {t.trustItems.map((item) => (
              <li key={item}>
                <span className="nz-trust__check" aria-hidden="true">
                  ✓
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
